import { Suspense, useCallback } from 'react';

import { Loader } from 'shared';

import { JournalNoteAddDialog } from 'features/journal';
import { useIsCoachMode } from 'features/user/hooks/useIsCoachMode';
import { useUserId } from 'features/user/hooks/useUserId';

import { modal, SIZES } from 'shared/components/Modal';

export const useOpenJournalAddNoteModal = ({
  challengeId,
  onAddNoteSuccess,
  customJournalPrompt,
}: {
  challengeId?: string;
  onAddNoteSuccess?: () => void;
  customJournalPrompt?: string;
} = {}) => {
  const ENV = process.env.REACT_APP_FRONTEND_ENVIRONMENT;
  const isDev = ENV === 'dev' || ENV === 'local';
  const isCoachMode = useIsCoachMode();
  const userId = useUserId();

  return useCallback(
    ({ challengeStatusDate }: { challengeStatusDate?: string } = {}) => {
      if (isCoachMode) {
        return;
      }

      if (isCoachMode && isDev) {
        console.error('HDEs cannot add notes on behalf of users');
      }

      modal.open({
        content: (
          <Suspense fallback={<Loader />}>
            <JournalNoteAddDialog
              challengeId={challengeId}
              challengeStatusDate={challengeStatusDate}
              onAddNoteSuccess={onAddNoteSuccess}
              participantId={userId}
              customJournalPrompt={customJournalPrompt}
            />
          </Suspense>
        ),
        props: {
          size: SIZES.MD,
        },
      });
    },
    [
      isCoachMode,
      isDev,
      challengeId,
      onAddNoteSuccess,
      userId,
      customJournalPrompt,
    ]
  );
};
